// React
import React from 'react';

// Utilities
import {
    useLabels,
    useContext,
    useInitiativeAndReportData,
    useResultHelpers,
} from 'utilities/hooks';

// Packages

// Data

// Components
import SectionContainer from 'components/_report/templates/report_5_0/sectionContainer';
import Collection from 'components/_report/templates/report_5_0/collection';
import { ReportUpdate } from 'components/_report/templates/report_5_0/_cards';

const SectionResultsComponent = ({
    utilities,
    items: navigationItems,
    CONSTANTS,
}) => {
    // ///////////////////
    // HOOKS
    // ///////////////////

    const { REPORT_ID } = useContext();
    const { label, getValueLabel } = useLabels();
    const { legacyMode } = useInitiativeAndReportData();
    const { getCardComponent, getTypeLabels } = useResultHelpers();

    // ///////////////////
    // DATA
    // ///////////////////

    const reflectionIds = utilities.reportDetails
        .getTypeResultsFromReportId(REPORT_ID)
        .map(reflection => reflection.Initiative_Result__c);

    // Get items with reflection
    const items = legacyMode
        ? utilities.results.getAll()
        : utilities.results
              .getAll()
              .filter(item => reflectionIds.includes(item.Id))
              .sort(
                  (a, b) =>
                      new Date(b.LastModifiedDate) -
                      new Date(a.LastModifiedDate)
              );

    const navigationItem = navigationItems[0] ?? {};

    // ///////////////////
    // RENDER
    // ///////////////////

    return (
        <div className="flex flex-col py-48 space-y-24">
            <SectionContainer
                {...{
                    item: navigationItem,
                }}>
                <Collection
                    {...{
                        collection: {
                            items,
                            emptyLabel: label('EmptyStateWizardPageResults'),
                        },
                        card: {
                            preTitle(item) {
                                return getTypeLabels(item.Id).type;
                            },
                            title(item) {
                                return item?.Name__c || item?.Name;
                            },
                            postTitle(item) {
                                return getTypeLabels(item.Id).subType;
                            },
                            components(item) {
                                const Component = getCardComponent(item.Id);
                                const cardContent = Component ? (
                                    <Component
                                        {...{
                                            item,
                                            theme: 'blue',
                                            utilities,
                                            CONSTANTS,
                                        }}
                                    />
                                ) : null;
                                return {
                                    cardContent,
                                    reportUpdate(additinalProps) {
                                        return (
                                            <ReportUpdateResult
                                                {...{
                                                    additinalProps,
                                                    item,
                                                    CONSTANTS,
                                                    utilities,
                                                }}
                                            />
                                        );
                                    },
                                };
                            },
                        },
                    }}
                />
            </SectionContainer>
        </div>
    );
};

const ReportUpdateResult = ({ additinalProps, item, CONSTANTS, utilities }) => {
    // ///////////////////
    // RENDER
    // ///////////////////

    return (
        <ReportUpdate
            {...{
                ...additinalProps,
                CONSTANTS,
                utilities,
                reflection: {
                    item,
                    relationKey: 'Initiative_Result__c',
                    type: CONSTANTS.REPORT_DETAILS.RESULTS,
                },
            }}
        />
    );
};

SectionResultsComponent.propTypes = {};

SectionResultsComponent.defaultProps = {};

export default SectionResultsComponent;
